// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index_wrapper__N1p5d","shade":"index_shade__vc7TH","market_con":"index_market_con__N3uLV"};